import { render, staticRenderFns } from "./CreateNewSpecialExam.vue?vue&type=template&id=6233ca44"
import script from "./CreateNewSpecialExam.vue?vue&type=script&lang=js"
export * from "./CreateNewSpecialExam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports